/* src/app/views/payment-legal-text-contract/payment-legal-text-contract-bra-preb/payment-legal-text-contract-bra-preb.component.scss */
.contract-wrapper {
  background: #ffffff;
  border: 1px solid #d8e0eb;
  border-radius: 14px;
  box-shadow: 0 10px 24px rgba(16, 43, 78, 0.08);
  overflow: hidden;
  padding: 48px 40px;
  margin: 0 auto 24px;
  width: 100%;
  max-width: 1200px;
  box-sizing: border-box;
  line-height: 1.6;
}
.contract-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 32px;
  padding-bottom: 32px;
  border-bottom: 2px solid #e5e7eb;
}
.contract-logo {
  width: 320px;
  height: 70px;
  object-fit: contain;
}
.contract-title {
  font-size: 22px;
  font-weight: 700;
  color: #00095b;
  text-align: center;
  margin: 0 0 40px 0;
  letter-spacing: 0.3px;
  line-height: 1.4;
  text-transform: uppercase;
}
.contract-section {
  margin-bottom: 36px;
  display: block;
  width: 100%;
  box-sizing: border-box;
}
.contract-section:last-child {
  margin-bottom: 0;
}
.section-title {
  font-size: 16px;
  font-weight: 700;
  color: #00095b;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #046cea;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.section-content {
  padding: 0;
  width: 100%;
  box-sizing: border-box;
  color: #1f2937;
  line-height: 1.7;
}
.section-subtitle {
  font-size: 15px;
  font-weight: 600;
  color: #00095b;
  margin: 0 0 12px 0;
  line-height: 1.5;
}
.section-text {
  font-size: 14px;
  font-weight: 400;
  color: #374151;
  margin: 0 0 16px 0;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1.75;
}
.section-text:last-child {
  margin-bottom: 0;
}
.vehicle-info-row {
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  padding: 12px 0;
  border-bottom: 1px solid #f3f4f6;
  gap: 16px;
}
.vehicle-info-row:last-child {
  border-bottom: none;
}
.vehicle-label {
  font-size: 15px;
  font-weight: 600;
  color: #00095b;
  min-width: 120px;
  display: inline-block;
}
.vehicle-value {
  font-size: 15px;
  font-weight: 500;
  color: #374151;
  flex: 1;
}
.notes-content {
  background: #f9fafb;
  padding: 20px;
  border-radius: 8px;
  border-left: 4px solid #046cea;
}
.note-item {
  font-size: 14px;
  color: #374151;
  margin: 0 0 16px 0;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1.75;
}
.note-item:last-child {
  margin-bottom: 0;
}
.note-item strong {
  color: #00095b;
  font-weight: 700;
  margin-right: 4px;
}
.insurance-info {
  background: #f3f4f6;
  padding: 20px;
  border-radius: 8px;
  margin: 28px 0;
}
.insurer-text {
  font-size: 13px;
  color: #4b5563;
  margin: 0 0 12px 0;
  text-align: justify;
  text-justify: inter-word;
  line-height: 1.6;
}
.insurer-text:last-child {
  margin-bottom: 0;
}
.regulation-list {
  font-size: 14px;
  color: #374151;
  margin: 16px 0 0 20px;
  padding: 0 0 0 20px;
  line-height: 1.75;
}
.regulation-list li {
  margin-bottom: 12px;
  text-align: justify;
  text-justify: inter-word;
}
.regulation-list li:last-child {
  margin-bottom: 0;
}
.contract-link {
  color: #046cea;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;
}
.contract-link:hover {
  color: #044ea7;
  text-decoration: underline;
}
.contract-link:visited {
  color: #0342a0;
}
@media (max-width: 768px) {
  .contract-wrapper {
    padding: 32px 24px;
  }
  .contract-header {
    margin-bottom: 24px;
    padding-bottom: 24px;
  }
  .contract-logo {
    width: 260px;
    height: 56px;
  }
  .contract-title {
    font-size: 18px;
    margin-bottom: 32px;
  }
  .section-title {
    font-size: 14px;
    margin-bottom: 12px;
    padding-bottom: 10px;
  }
  .section-content {
    padding: 0;
  }
  .section-text,
  .insurer-text,
  .note-item {
    font-size: 13px;
  }
  .vehicle-info-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    padding: 10px 0;
  }
  .vehicle-label {
    min-width: auto;
  }
}
@media (max-width: 500px) {
  .contract-wrapper {
    padding: 24px 16px;
  }
  .contract-header {
    margin-bottom: 20px;
    padding-bottom: 20px;
  }
  .contract-logo {
    width: 220px;
    height: 48px;
  }
  .contract-title {
    font-size: 16px;
    margin-bottom: 24px;
  }
  .contract-section {
    margin-bottom: 28px;
  }
  .section-title {
    font-size: 13px;
    margin-bottom: 10px;
  }
  .section-text,
  .insurer-text,
  .note-item {
    font-size: 12px;
  }
  .regulation-list {
    font-size: 12px;
    margin-left: 16px;
    padding-left: 16px;
  }
}
/*# sourceMappingURL=payment-legal-text-contract-bra-preb.component-LUG2VQJ2.css.map */
